import { render } from "./icon-reviewed-not-by-you-counter-3.svg?vue&type=template&id=a6f0aa77&scoped=true&component"
const script = {}

import "./icon-reviewed-not-by-you-counter-3.svg?vue&type=style&index=0&id=a6f0aa77&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f0aa77"]])

export default __exports__